import "./styles/style.scss";
import "viewerjs/dist/viewer.css";

import Vue from "vue";
import VueRouter from "vue-router";
import Viewer from "v-viewer";
import App from "./App.vue";
import Concepts from "./Concepts.vue";
import Narrative from "./Narrative.vue";
import Framework from "./Framework.vue";
import Documents from "./Documents.vue";
import Document from "./Document.vue";
import About from "./About.vue";
import Workshops from "./Workshops.vue";
import Resources from "./Resources.vue";

Vue.use(VueRouter);
Vue.use(Viewer);

const routes = [
  { path: "/", name: "home", component: App },
  { path: "/narrative", name: "narrative", component: Narrative },
  { path: "/concepts", name: "concepts", component: Concepts },
  { path: "/framework", name: "framework", component: Framework },
  { path: "/documents", name: "documents", component: Documents },
  {
    path: "/document/:document_id",
    name: "document",
    component: Document,
    props: true
  },
  { path: "/about", component: About },
  { path: "/workshops", component: Workshops },
  { path: "/resources", component: Resources }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

new Vue({
  router
}).$mount("#app");
